import { ArrowLeft, Check, User, CreditCard, Smartphone, Calendar, X, Search, Book, NotebookPen } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./index.css";
import CountryPhoneList from "../../../../components/input/InputPhoneTel";
import CashPayment from "../paymentWindow/CashPayment";
import CardPayment from "../paymentWindow/CardPayment";
import MobilePay from "../paymentWindow/MobilePay";
import CashPaymentOverlay from "../paymentWindow/CashPayment";
import { modifyTansactionData } from "../../../../tools/indexdb";
import { clearCart } from "../../../../slice/sellingCarts";
import { updateNotification } from "../../../../slice/notificationSlice";
import { clearMultipleLoansUrl, createTransactionUrl, fetchCustomerTransactionsUrl, pushPaymentKudaUrl } from "../../../../api/endpoints";
import { addToQueue, setRefreshTransaction } from "../../../../slice/offlineQueue";
import { registerReminderForLoan } from "../ConfirmSelection";
import { uiAlert } from "../../../../components/alerts/customAlert/uiAlert";
import BookingOverlay from "../bookOrder/BookOrder";
import CustomerBalanceChecker from "./CustomerBalanceCheck";
import ExtraChargesCard from "./extraCharges/ExtrachargesCard";
import PaymentMode from "./checkOutPaymentAccount/PaymentMode";

export const generateTransactionID = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = today.getFullYear();
  const dateNum = `${day}${month}${year}`; // e.g., "12042025

  // 1) Generate a UUID, remove hyphens, convert to base-36 → ~25 chars
  const rawUuid = crypto.randomUUID().replace(/-/g, ""); // 32 hex chars
  /*  const shortId = BigInt("0x" + rawUuid)
        .toString(36)
        .toUpperCase(); // 24-25 chars */
  let hexNumber = "";
  for (let i = 0; i < rawUuid.length; i++) {
    hexNumber += String(parseInt(rawUuid[i], 16)); // Safe hex-to-decimal conversion
  }
  const shortId = parseInt(hexNumber.slice(0, 15), 10).toString(36).toUpperCase(); // Truncate to avoid overflow
  // 3. Combine date + shortId (e.g., "12042025_ABC123")
  return dateNum + rawUuid;
};

const CustomerDetails = ({ whichCompToRender, createdTransaction, setAlertDisplay, socket }) => {
  const navigate = useNavigate();
  const [isLoanPayment, setIsLoanPayment] = useState(false);
  const [showCustomerList, setShowCustomerList] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [initialPayment, setInitialPayment] = useState(0);
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentMode, setPaymentMode] = useState("cash");
  const [payment, setPayment] = useState(null);

  const [deliveryStatus, setDeliveryStatus] = useState("supplied");
  const [searchTerm, setSearchTerm] = useState("");
  const [showBooking, setShowBooking] = useState(false);

  // my state

  const [customer, setCustomer] = useState({
    customerID: null,
    name: "",
    email: "",
    phoneNumber: "",
    address: "",
  });
  const [openSelectCustomer, setOpenSelectCustomer] = useState(false);
  const [operationType, setOperationType] = useState();
  const [isOperationTypeValid, setIsOperationTypeValid] = useState(false);
  const [comment, setComment] = useState("");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //
  const { cartItem, total, discount, vat, vatPercentage } = useSelector((state) => state.sellingCart);
  const [searchString, setSearchString] = useState("");
  const [openPaymentWindow, setOpenPaymentWindow] = useState(false);
  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);
  /*  const [totalAmount, setTotalAmount] = useState(Math.ceil(Number(total + (vat ? vat : 0)) - Number(discount))); */
  const [extraBalance, setExtraBalance] = useState(0); // balance from previous transactions with the same customer that can be added to the current transaction total
  const [runClearLoanTransactions, setRunClearLoanTransactions] = useState({
    run: false,
    transactions: [],
    addToStoresClearedLoan: true,
  }); // flag to trigger clearing of loan transactions when adding previous balance to current transaction total
  const [extraCharges, setExtraCharges] = useState([]); // array of extra charges to be added to the transaction

  const transID = useMemo(() => generateTransactionID(), [cartItem]); // generate a unique transaction ID for the current transaction

  /* const totalAmount = Math.ceil(Number(total + (vat ? vat : 0)) - Number(discount)); */
  const dispatch = useDispatch();

  const checklistSteps = [
    { id: 1, title: "Select product", completed: true },
    { id: 2, title: "Confirm Selected products", completed: true },
    { id: 3, title: "Operation type and customer info", active: true },
    { id: 4, title: "Confirmation", completed: false },
  ];

  // if loan is true, then delivery status should be not supplied, else supplied
  useEffect(() => {
    if (isLoanPayment) {
      setDeliveryStatus("supplied");
    }
  }, [isLoanPayment]);

  useEffect(() => {
    // Validate form when initial payment or payment date changes
    const isPaymentValid = !isLoanPayment || (initialPayment < totalAmount && paymentDate);
    const isDateValid = !isLoanPayment || new Date(paymentDate) > new Date();
    setIsFormValid(isPaymentValid && isDateValid);
  }, [initialPayment, paymentDate, isLoanPayment]);

  const handleOperationTypeChange = (type) => {
    setIsLoanPayment(type === "loan");
  };

  const baseTotal = Math.ceil(Number(total + (vat || 0)) - Number(discount || 0));

  const extraChargesTotal = extraCharges.reduce((sum, charge) => sum + Number(charge.amount || 0), 0);

  const totalAmount = baseTotal + Number(extraBalance || 0) + extraChargesTotal;

  const handleCustomerSelect = (customer) => {
    console.log("Selected customer:", customer);
    setSelectedCustomer(customer);
    setCustomer({
      customerID: customer.customerID,
      name: customer.fullName,
      email: customer.email,
      phoneNumber: customer.phoneNumber,
      address: customer.address,
    });
    setShowCustomerList(false);
  };
  function stripLeadingZeros(value) {
    if (value == null) return 0; // handle null/undefined
    return Number(value.toString().replace(/^0+/, "") || "0");
  }
  const handleSellItems = async () => {
    try {
      setIsLoading(true);

      if (!isFormValid) {
        console.log(getValidationMessage(), "getValidationMessage");
        let mesg = getValidationMessage();
        console.log(mesg, "mesg");

        uiAlert(mesg, "error");
        setIsLoading(false);
        return;
      }

      if (runClearLoanTransactions.run) {
        const status = await handleClearLoanTransactions(runClearLoanTransactions.transactions, runClearLoanTransactions.addToStoresClearedLoan);

        if (!status) {
          return;
        }
      }

      let accessToken = localStorage.getItem("accessToken");
      let date = new Date(); // Get current date in ISO format
      let offsetDate = new Date(); // Get current date in ISO format

      //build the payload
      const deliveryFee = extraCharges.find((charge) => charge.type === "deliveryFee")?.amount || 0;
      const serviceCharge = extraCharges.find((charge) => charge.type === "serviceCharge")?.amount || 0;
      const extraPayment = extraCharges.find((charge) => charge.type === "extraPayment")?.amount || 0;

      if (payment?.isSplit) {
        const hasInvalidSplit = payment.splits?.some((split) => !split?.paymentType);

        if (!payment.splits?.length || hasInvalidSplit) {
          uiAlert("Please select a payment type for every payment.", "error");
          setIsLoading(false);
          return;
        }
      } else {
        if (!payment?.paymentType) {
          uiAlert(
            "Please select a payment mode. You must choose a payment type before proceeding. Otherwise add a receiving account from your store profile first.",
            "error",
          );
          setIsLoading(false);
          return;
        }
      }
      const payments_ = payment.isSplit
        ? payment.splits.map((split) => ({
            paymentType: split.paymentType,
            amount: split.amount,
            account: split.accountId,
            receivingAccountName: split.accountName,
            reference: split.reference,
            paidAt: new Date(),
            isPartner: split.isPartner,
          }))
        : [
            {
              paymentType: payment.paymentType,
              amount: payment.amountPaid,
              account: payment.accountId,
              receivingAccountName: payment.accountName,
              reference: payment.reference,
              paidAt: new Date(),
              isPartner: payment.isPartner,
            },
          ];

      let transactionPayload = {
        transactionDetails: {
          date: date,
          deliveryStatus: deliveryStatus === "supplied" ? "supplied" : "notSupplied",
          paymentMode: payment.isSplit ? "split" : payment.paymentType,
          payments: payments_,
          numberOfItems: cartItem.length,
          subTotal: total,
          vat: vat ? vat : 0,
          vatPercentage: vatPercentage ? vatPercentage : 0,
          deliveryFee: deliveryFee,
          serviceCharge: serviceCharge,
          extraPayment: extraPayment,
          totalAmount: totalAmount,
          clearedbalance: extraBalance, // if there is extra balance from previous transactions with the same customer, subtract it from the current transaction total
          discount: discount ? discount : 0,
        },
        soldBy: {
          employeeID: null,
          fullName: "Admin",
        },
        customer: {
          customerID: customer.customerID ? customer.customerID : null, // if customer is not on platform, it will be null
          fullName: customer.name ? customer.name : "Anonymous Customer", // if customer is not on platform, it will be Anonymous Customer
          email: customer.email ? customer.email : "No Email",
          phoneNumber: customer.phoneNumber ? customer.phoneNumber : "No phone number" /* format phone number to become string */,
          address: customer.address ? customer.address : "No Address", // if customer is not on platform, it will be No Address
          storePurchaseFrom: { storeName: store.storeName, storeID: store._id },
          purchaseChannel: "inStore", // or online
          totalPurchaseAmount: totalAmount,
          userType: "notOnPlatform",
          amountOwned: !isLoanPayment ? 0 : Number(totalAmount) - Number(initialPayment), // if not loan payment, amount owned is 0, else it is total - initial payment
        },
        webstoreUserID: user._id,
        store: {
          id: store._id,
          name: store.storeName,
        },
        products: cartItem.map((item, i) => {
          return {
            id: item.isSubUnitSold ? item.productId : item._id,
            name: item.name,
            brand: item.brand,
            isSubUnitSold: item.isSubUnitSold ? true : false,
            category: item.productCategory,
            unit: item.unit,
            subUnitId: item.subUnitId ? item.subUnitId : null,
            serialNumber: item.serialNumber ? item.serialNumber : null,
            productCostPrice: item.costPrice,
            soldUnitPrice: item.soldUnitPrice,
            quantity: item.soldQuantity,
            totalAmount: item.totalPrice,
            productImage:
              item?.productImage?.[0] || "https://res.cloudinary.com/ebuka1122/image/upload/v1792768190/Ihub-product-images/fu82jfjnwdqkxo4cf3pm.png",
            returned: false,
            returnedDate: null,
            supplied: deliveryStatus === "supplied" ? true : false, // if delivery status is supplied, then supplied is true, else false
            suppliedDate: deliveryStatus === "supplied" ? offsetDate : null,
          };
        }),
        operationType: {
          whichOperation: !isLoanPayment ? "cash" : "loan",
          loanDate: !isLoanPayment ? null : offsetDate,
          intialPayment: !isLoanPayment ? null : stripLeadingZeros(initialPayment),

          balance: !isLoanPayment ? null : Number(totalAmount) - stripLeadingZeros(initialPayment),
          dateToPay: isLoanPayment ? paymentDate : null,
          loanDuration: isLoanPayment ? new Date(paymentDate) - new Date() : null,
        },
        comments: comment,
        transID: transID,
        currency: user.userCountryCurrencySymbol ? user.userCountryCurrencySymbol : "₦",
      };

      let { UpdatedStoreProductCollection, productsAppraochingStockLimitNames, shouldSendNotification, error } = await modifyTansactionData(
        store.storeName,
        transactionPayload,
        "todayTransactions",
      );

      if (error) {
        return uiAlert(error || "Transaction failed, some products in the transaction have insufficient stock", "error");
      }

      createdTransaction(transactionPayload);
      dispatch(clearCart());
      whichCompToRender("TransactionSuccess");
      setIsLoading(false);
      setAlertDisplay({
        showAlert: true,
        type: "success",
        title: "Transaction successful",
        message: "You have successfully registered a transaction",
      });
      dispatch(updateNotification(shouldSendNotification));
      if (productsAppraochingStockLimitNames.length > 0) {
        uiAlert("Some Products are approaching stock limit,check the stock and restock");
      }
      //build offline queue payload
      let offlineQueueItem = {
        fetchPayload: transactionPayload,
        fetchUrl: createTransactionUrl + store._id,
        fetchMethod: "POST",
        fetchAccessToken: accessToken,
        storeID: store._id,
        queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
      };

      //add to offline queue

      dispatch(addToQueue(offlineQueueItem));

      setOpenPaymentWindow(false); // Close payment window if open
      // Emit loan transaction event to socket
      transactionPayload.operationType.whichOperation === "loan" && registerReminderForLoan(transactionPayload, socket, store);
    } catch (error) {
      console.error("Error creating transaction:", error);
      setAlertDisplay({ type: "error", message: "Failed to create transaction. Please try again." });
      return;
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelSales = () => {
    // Navigate back to product selection or handle cancel
    whichCompToRender("SelectProduct");
  };

  const getValidationMessage = () => {
    console.log(isLoanPayment, initialPayment, paymentDate, "validation state");

    if (isLoanPayment && initialPayment !== 0 && !initialPayment) return "Please Enter initial payment amount";
    if (isLoanPayment && !paymentDate) return "Please select a date to pay";

    const payment = parseFloat(initialPayment);
    const today = new Date();
    const selectedDate = new Date(paymentDate);

    const isPaymentInvalid = payment >= totalAmount;
    const isDateInvalid = selectedDate <= today;
    console.log(isPaymentInvalid, isDateInvalid, "validation checks");

    if (isPaymentInvalid && isDateInvalid) {
      return "Initial payment should be lower than transaction total and date must not be in the past";
    } else if (isPaymentInvalid) {
      return "Initial payment should be lower than transaction total";
    } else if (isDateInvalid) {
      return "Date must not be in the past";
    }

    return "";
  };

  const fetchCustomerTransactions = async (customerID) => {
    const url = `${fetchCustomerTransactionsUrl}${store._id}/${customerID}`;

    try {
      let response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.status === 404) {
        uiAlert(`No transactions found for ${customer.name}`, "info");
        return {
          transactions: [],
          totalbalance: 0,
        };
      }
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      let { transactions, totalbalance } = await response.json();

      return {
        transactions,
        totalbalance,
      };
    } catch (error) {
      uiAlert(`Failed to credit sales fro ${customer.name} `, "error");

      return {
        transactions: [],
        totalbalance: 0,
      };
    }
  };

  const isTransactionFromToday = (transactionDate) => {
    if (!transactionDate) return false;

    const txDate = new Date(transactionDate);
    const today = new Date();

    return txDate.getFullYear() === today.getFullYear() && txDate.getMonth() === today.getMonth() && txDate.getDate() === today.getDate();
  };

  const handleClearLoanTransactions = async (transactions, addToStoresClearedLoan) => {
    //clear loan trans with payload let { transactionIDs, totalClearedAmount, paymentMode, addToStoresClearedLoan = true, employee = null }
    const url = `${clearMultipleLoansUrl}${store._id}/`;

    //check if any transaction is from today if yes set reduce store to refresh page
    const hasTodayTransaction = transactions.some((tx) => isTransactionFromToday(tx.transactionDetails?.date));

    console.log("Clearing loan transactions with payload:", hasTodayTransaction, transactions, addToStoresClearedLoan);

    dispatch(setRefreshTransaction(hasTodayTransaction));

    const payload = {
      transactionIDs: transactions.map((tx) => tx.transID),
      totalClearedAmount: transactions.reduce((sum, tx) => sum + Number(tx.operationType?.balance || 0), 0),
      paymentMode: paymentMode,
      addToStoresClearedLoan: addToStoresClearedLoan,
      employee: null,
    };

    try {
      let response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response || typeof response.json !== "function") {
        throw new Error("Invalid server response. Request may have failed.");
      }

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Network response was not ok");
      }

      return true;
    } catch (error) {
      console.log(error);

      uiAlert(error?.message || "Failed to clear previous loan transactions", "error");
      setIsLoading(false);
      return false;
    }
  };

  const pushToTerminal = async ({ accountId, accountName, provider, amount, sellToken, postype, serialNumber }) => {
    // try to push to KUDA terminal

    console.log(accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID);

    const url = `${pushPaymentKudaUrl}${store._id}/`;

    try {
      let response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({ accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID }),
      });

      /* uiAlert(`Successfully pushed ${amount} to ${accountName} via ${provider}`, "success"); */

      /*    return { success: true, message: "Transaction successful" }; */
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        return {
          success: false,
          message: data?.message || "Failed to push to terminal",
          data,
        };
      }

      return {
        success: true,
        message: data?.message || (response.ok ? "Transaction successful" : "Failed to push to terminal"),
        data,
      };
    } catch (error) {
      console.error("Error pushing to terminal:", error);
      return {
        success: false,
        message: error.message || "Failed to push to terminal",
        error,
      };
    }

    /* return uiAlert(`Pushing ${user.userCountryCurrencySymbol}${amount} to ${accountName} via ${provider} is pending `, "info"); */

    /* return new Promise((resolve, reject) => {
      
        // Simulate a successful push to terminal
        const success = true; // Change this to false to simulate failure
        if (success) {
          resolve();
        } else {
          uiAlert(`Failed to push ${amount} to ${accountName} via ${provider}`, "error");
          reject(new Error("Failed to push to terminal"));
        }
     
    }) */
  };

  return (
    <>
      <div className='customer-details-container'>
        <div className='customer-details-wrapper'>
          {/* Mobile Progress Bar */}
          <div className='mobile-progress-container'>
            <div className='mobile-progress-inner'>
              {checklistSteps.map((step, index) => (
                <div key={step.id} className='mobile-progress-step'>
                  <div className={`mobile-progress-circle ${step.completed ? "completed" : step.active ? "active" : "inactive"}`}>
                    {step.completed ? <Check className='progress-icon' /> : <span>{step.id}</span>}
                  </div>
                  {index < checklistSteps.length - 1 && <div className={`mobile-progress-connector ${step.completed ? "completed" : "inactive"}`} />}
                </div>
              ))}
            </div>
          </div>

          <div className='customer-details-layout'>
            {/* Main Content */}
            <div className='main-content-section'>
              {/* Header */}
              {/*  <div className='page-header'>
                    <button className='back-btn' onClick={handleBack}>
                      <ArrowLeft className='back-icon' />
                    </button>
                    <h1 className='page-heading'>Transaction details & Customer information</h1>
                    <div className='items-indicator'>
                      <div className='items-badge'>
                        <span className='items-count'>3 Item to sell</span>
                      </div>
                    </div>
                  </div> */}

              {/* Form Content */}
              <div className='form-container'>
                <div className='form-content'>
                  {/* Operation Type */}
                  <div className='form-section'>
                    <h2 className='section-title'>
                      Operation type <span className='required-asterisk'>*</span>
                    </h2>
                    <div className='radio-group'>
                      <label className={`radio-option ${!isLoanPayment ? "selected" : ""}`}>
                        <input type='radio' name='operation' value='full' checked={!isLoanPayment} onChange={() => handleOperationTypeChange("full")} />
                        <div className='radio-circle'>
                          <div className='radio-dot'></div>
                        </div>
                        <span className='radio-label'>Full payment</span>
                      </label>
                      <label className={`radio-option ${isLoanPayment ? "selected" : ""}`}>
                        <input type='radio' name='operation' value='loan' checked={isLoanPayment} onChange={() => handleOperationTypeChange("loan")} />
                        <div className='radio-circle'>
                          <div className='radio-dot'></div>
                        </div>
                        <span className='radio-label'>Loan (part payment)</span>
                      </label>
                    </div>

                    {/* Loan Payment Fields */}
                    {isLoanPayment && (
                      <div className='loan-payment-fields'>
                        <div className='loan-input-row'>
                          <div className='loan-input-group'>
                            <label className='loan-input-label'>Enter initial pay</label>
                            <div className='currency-input'>
                              <span className='currency-prefix'>{user.userCountryCurrencySymbol}</span>
                              {/*    <input
                                min={0}
                                type='number'
                                value={initialPayment}
                                onChange={(e) => {
                                  // Validate input to ensure it's a number and not empty
                                  if (e.target.value === "" || !isNaN(e.target.value)) {
                                    setInitialPayment(0); // Reset to 0 if input is empty
                                  }
                                  setInitialPayment(e.target.value);
                                }}
                                placeholder='9999'
                                className='loan-input'
                              /> */}
                              <input
                                type='text'
                                inputMode='numeric'
                                pattern='[0-9]*'
                                value={initialPayment === "" ? "" : Number(initialPayment).toLocaleString("en-US")}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/,/g, "").replace(/\D/g, "");

                                  setInitialPayment(value);
                                }}
                                placeholder='9,999'
                                className='loan-input'
                              />
                            </div>
                          </div>

                          <div className='loan-input-group'>
                            <label className='loan-input-label'>Date to pay</label>
                            <div className='date-input-wrapper'>
                              <input type='date' value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} className='loan-input date-input' />
                              <Calendar className='date-icon' />
                            </div>
                          </div>
                        </div>

                        {getValidationMessage() && (
                          <div className='validation-message'>
                            <span className='validation-icon'>⚠</span>
                            {getValidationMessage()}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Delivery Status */}
                  <div className='form-section'>
                    <h2 className='section-title'>Delivery status</h2>
                    <div className='radio-group'>
                      <label className={`radio-option ${deliveryStatus === "supplied" ? "selected" : ""}`}>
                        <input
                          type='radio'
                          name='delivery'
                          value='supplied'
                          checked={deliveryStatus === "supplied"}
                          onChange={(e) => setDeliveryStatus(e.target.value)}
                        />
                        <div className='radio-circle'>
                          <div className='radio-dot'></div>
                        </div>
                        <span className='radio-label'>Supplied</span>
                      </label>
                      <label className={`radio-option ${deliveryStatus === "not-supplied" ? "selected" : ""}`}>
                        <input
                          //   disabled={isLoanPayment} // Disable if loan payment is selected
                          type='radio'
                          name='delivery'
                          value='not-supplied'
                          checked={deliveryStatus === "not-supplied"}
                          onChange={(e) => setDeliveryStatus(e.target.value)}
                        />
                        <div className='radio-circle'>
                          <div className='radio-dot'></div>
                        </div>
                        <span className='radio-label'>Not supplied</span>
                      </label>
                    </div>
                  </div>

                  <PaymentMode
                    totalDue={isLoanPayment ? Number(initialPayment || 0) : Number(totalAmount || 0)}
                    paymentAccounts={store?.storeReceivingAccounts || []}
                    onChange={setPayment}
                  />
                </div>
              </div>
            </div>

            {/* Customer Details Sidebar */}
            <div className='customer-sidebar'>
              <div className='sidebar-card-customer'>
                <div className='sidebar-header-customer'>
                  <h2 className='sidebar-title-customer'>Customer details</h2>
                  <button className='add-customer-btn' onClick={() => setShowCustomerList(true)}>
                    <span>Add</span>
                    <User className='add-icon' />
                  </button>
                </div>

                <div className='customer-form'>
                  <div className='form-group'>
                    <input
                      type='text'
                      placeholder='Name'
                      className='form-input'
                      value={customer.name}
                      onChange={(e) => setCustomer({ ...customer, name: e.target.value })}
                    />
                  </div>

                  <div className='form-group'>
                    <input
                      type='email'
                      placeholder='Email'
                      className='form-input'
                      value={customer.email}
                      onChange={(e) => setCustomer({ ...customer, email: e.target.value })}
                    />
                  </div>

                  <div className='form-group'>
                    <div className='phone-input-group '>
                      {/*  <div className='country-flag'>🇩🇰</div>
                          <input
                            type='tel'
                            placeholder='Enter phone number*'
                            className='form-input phone-input'
                            value={selectedCustomer?.phone || ""}
                            onChange={(e) => {
                              if (selectedCustomer) {
                                setSelectedCustomer({ ...selectedCustomer, phone: e.target.value });
                              }
                            }}
                          
                          /> */}
                      <CountryPhoneList
                        value={customer.phoneNumber}
                        setPhone={setCustomer}
                        customer={customer}
                        isPhoneNumberValidFucn={setIsPhoneNumberValid}
                      />
                    </div>
                  </div>
                  {customer.phoneNumber && !isPhoneNumberValid && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "-15px",
                      }}
                    >
                      Phone number is not valid
                    </p>
                  )}

                  <div className='form-group'>
                    <input
                      type='text'
                      placeholder='Address'
                      className='form-input'
                      value={customer.address}
                      onChange={(e) => setCustomer({ ...customer, address: e.target.value })}
                      required
                    />
                  </div>

                  <div className='form-group'>
                    <textarea
                      placeholder='Add a comment if any (optional)'
                      className='form-textarea'
                      rows='4'
                      maxLength={200}
                      value={comment}
                      onChange={(e) => {
                        setComment(e.target.value);
                      }}
                    ></textarea>
                  </div>
                </div>
                <CustomerBalanceChecker
                  customerID={customer.customerID}
                  customerName={customer.name}
                  currency={user.userCountryCurrencySymbol}
                  fetchBalance={async (id) => {
                    const { transactions, totalbalance } = await fetchCustomerTransactions(id);

                    return {
                      balance: totalbalance,
                      transactions: transactions,
                    };
                  }}
                  onAddToTransaction={(balance, txs) => {
                    // add balance to current sale total
                    setExtraBalance(balance);
                    //recalculet the total
                    // setTotalAmount((prevTotal) => prevTotal + balance);
                    setRunClearLoanTransactions({
                      run: true,
                      transactions: txs,
                      addToStoresClearedLoan: false,
                    });
                    //handleClearLoanTransactions(txs, true);
                  }}
                  onClearBalance={(txs) => {
                    // call your clear endpoint
                    console.log("Clear balance called");
                    setExtraBalance(0);

                    setRunClearLoanTransactions({
                      run: true,
                      transactions: txs,
                      addToStoresClearedLoan: true,
                    });

                    //  handleClearLoanTransactions(txs, false);
                  }}
                  onCancel={() => {
                    //  setTotalAmount(Math.ceil(Number(total + (vat ? vat : 0)) - Number(discount)));
                    setExtraBalance(0);

                    setRunClearLoanTransactions({
                      run: false,
                      transactions: [],
                      addToStoresClearedLoan: true,
                    });
                  }}
                />
                <ExtraChargesCard charges={extraCharges} onChange={setExtraCharges} currency={user.userCountryCurrencySymbol} />
              </div>
            </div>
          </div>

          {/* Bottom Action Bar */}
          <div className='bottom-action-bar'>
            <div className='action-left-section'>
              <button className='cancel-sales-btn' onClick={handleCancelSales}>
                Cancel sales
              </button>
            </div>
            {/*   <div className='total-section'>
              <span className='total-label'>Total:</span>
              <span className='total-amount'>kr {(Number(totalAmount || 0) - Number(discount || 0)).toLocaleString()}</span>
            </div> */}
            <div className='sellOrderbtnWrapp'>
              <button className='sell-items-btn sellIteme2' onClick={() => setOpenPaymentWindow(true)}>
                Sell items ({user.userCountryCurrencySymbol}
                {totalAmount.toLocaleString()})
              </button>
              <button className='sell-items-btn bookOr-btn' onClick={() => setShowBooking(true)}>
                <NotebookPen size={18} />
                Book
              </button>
            </div>
          </div>

          {/* Customer List Overlay */}
          {showCustomerList && (
            <div onClick={() => setShowCustomerList(false)} className='customer-overlay'>
              <div onClick={(e) => e.stopPropagation()} className='customer-modal'>
                <div className='customer-modal-header'>
                  <h3 className='customer-modal-title'>Select Customer</h3>
                  <button className='close-modal-btn' onClick={() => setShowCustomerList(false)}>
                    <X className='close-icon' />
                  </button>
                </div>

                <div className='customer-search-section'>
                  <div className='search-input-wrapper'>
                    <Search className='search-icon' />
                    <input
                      type='text'
                      placeholder='Search customers by name...'
                      className='customer-search-input'
                      value={searchString}
                      onChange={(e) => setSearchString(e.target.value)}
                    />
                  </div>
                </div>

                <div className='customer-list'>
                  {store.offlineCustomers.length > 0 ? (
                    store.offlineCustomers
                      .filter((cust) => cust.id.fullName.toLowerCase().includes(searchString.toLowerCase()))
                      .map((customer, i) => (
                        <div key={i} className='customer-item' onClick={() => handleCustomerSelect(customer.id)}>
                          <div className='customer-avatar'>
                            <User className='avatar-icon' />
                          </div>
                          <div className='customer-info'>
                            <div className='customer-name'>{customer.id.fullName}</div>
                            <div className='customer-email'>{customer.id.email}</div>
                            <div className='customer-details'>
                              <span className='customer-phone'>{customer.id.phoneNumber}</span>
                              <span className='customer-address'>{customer.id.address}</span>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div className='no-customers-found'>
                      <div className='no-customers-icon'>
                        <User className='no-results-icon' />
                      </div>
                      <p className='no-customers-text'>No customers found</p>
                      <p className='no-customers-subtext'>New customers are added automatically when they make a purchase</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {console.log("paymentMode", paymentMode, "openPaymentWindow", openPaymentWindow, "isLoanPayment", isLoanPayment)}
      {openPaymentWindow && (
        <CashPaymentOverlay
          sellItems={handleSellItems}
          currency={user.userCountryCurrencySymbol}
          total={totalAmount}
          discount={stripLeadingZeros(discount)}
          vat={vat}
          cancel={setOpenPaymentWindow}
          transDetail={{
            cash: !isLoanPayment,
            loanDetails: {
              initialPay: isLoanPayment ? stripLeadingZeros(initialPayment) : null,
              dateToPay: isLoanPayment ? paymentDate : null,
              balance: isLoanPayment ? totalAmount - stripLeadingZeros(initialPayment) : null,
            },
          }}
          isLoading={isLoading}
          payment={payment}
          pushToTerminal={async (entry) => {
            return await pushToTerminal(entry);
          }}
          socket={socket}
          transID={transID}
        />
      )}

      {showBooking && (
        <BookingOverlay
          showBooking={showBooking}
          setShowBooking={setShowBooking}
          currency={user.userCountryCurrencySymbol}
          cartItems={cartItem}
          customer={customer}
          discount={stripLeadingZeros(discount)}
          onRegistrationComplete={() => {
            dispatch(clearCart());
            whichCompToRender("CashTransactionComp");
          }}
        />
      )}
    </>
  );
};

export default CustomerDetails;
